module.exports = __webpack_public_path__ + "static/media/angle-up.fd6de809.svg";